// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__26Bg8","small-icon":"styles_small-icon__1EkCJ"};